// extracted by mini-css-extract-plugin
export default {"content":"gk45cX4W7VyzWYeWnDNe__content___","title":"cBsn9EEYVvwqCW__sxc4__title___"};